import { render, staticRenderFns } from "./WpUninstallPanel.vue?vue&type=template&id=288fe10b&scoped=true&"
import script from "./WpUninstallPanel.vue?vue&type=script&lang=ts&"
export * from "./WpUninstallPanel.vue?vue&type=script&lang=ts&"
import style0 from "./WpUninstallPanel.vue?vue&type=style&index=0&id=288fe10b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288fe10b",
  null
  
)

export default component.exports